import { Link } from 'react-router-dom'
import { useMe } from '../../api/queries'
import { AuthShell } from './AuthShell'

/**
 * Экран 1.4 «Доступ ограничен».
 *
 * Два разных случая, и путать их нельзя.
 *   blocked      — наказание: расписание видно, бронировать нельзя.
 *   deactivated  — сотрудник уволился: войти нельзя вовсе.
 *
 * В обоих случаях экран называет причину и того, к кому идти. Тупик без объяснения —
 * самый верный способ получить звонок в поддержку.
 */
export function BlockedPage() {
  const { data } = useMe({ retry: false })
  const status = data?.user.status

  if (status === 'deactivated') {
    return (
      <AuthShell title="Учётная запись отключена">
        <p className="text-sm text-muted">
          Эта запись деактивирована — обычно так помечают сотрудников, которые больше не работают
          в компании. История встреч сохранена, но входить в систему нельзя.
        </p>
        <p className="mt-3 text-sm text-muted">
          Если это ошибка, попросите администратора системы вернуть доступ.
        </p>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="Бронирование недоступно">
      <p className="text-sm text-muted">
        Ваш адрес в чёрном списке: создавать и переносить встречи сейчас нельзя. Расписание
        переговорных при этом открыто, и встречи, куда вас позвали, тоже видны.
      </p>
      <p className="mt-3 text-sm text-muted">
        Снять ограничение может администратор системы — обратитесь к нему.
      </p>
      <Link to="/" className="mt-6 inline-block text-sm font-medium text-accent hover:underline">
        Вернуться к расписанию
      </Link>
    </AuthShell>
  )
}
